import {STANDARDS_FETCHED} from "../types";
import {pageLoaded} from "./page";
import api from "../api";

export const standardsFetched = standards => ({
    type: STANDARDS_FETCHED,
    standards
});


export const fetchedStandards = () => (dispatch, getState) =>
  api.reviewTool.fetchStandards().then(res => {
      dispatch(standardsFetched(res))
      dispatch(pageLoaded({'loaded' : true}))
  });






// WEBPACK FOOTER //
// ./src/actions/reviewtool.js